// extracted by mini-css-extract-plugin
module.exports = {"handle":"Handle_handle__1esyB"};